module.exports = __webpack_public_path__ + "img/wb.f2fa2bcc.svg";